"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cutString = exports.byteLength = void 0;
var tslib_1 = require("tslib");
function byteLength(target) {
    var length = 0;
    var targetLength = target.length;
    if (targetLength) {
        for (var i = 0; i < targetLength; i++) {
            if (target.charCodeAt(i) > 255) {
                length += 2;
            }
            else {
                length++;
            }
        }
        return length;
    }
    return 0;
}
exports.byteLength = byteLength;
function cutString(target, maxLength, isChineseAsTwoBytes) {
    var strArray = tslib_1.__spreadArray([], tslib_1.__read(target), false);
    if (!isChineseAsTwoBytes) {
        return strArray.slice(0, maxLength).join('');
    }
    for (var i = 0; i < strArray.length; i++) {
        var cutIndex = i + 1;
        var sub = strArray.slice(0, cutIndex).join('');
        if (maxLength === byteLength(sub)) {
            return sub;
        }
        if (maxLength < byteLength(sub)) {
            return strArray.slice(0, cutIndex - 1).join('');
        }
    }
    return target;
}
exports.cutString = cutString;
//# sourceMappingURL=byteLength.js.map